var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_29013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2056 23.3931C27.049 24.7861 25.3854 26.2026 23.4619 27.8449C22.808 28.403 22.0603 29.0378 21.2871 29.713C21.0832 29.8917 20.8212 29.9902 20.5501 29.9902C20.2789 29.9902 20.017 29.8917 19.8131 29.713C19.0399 29.0378 18.2922 28.403 17.6383 27.8449C15.7212 26.2026 14.0512 24.7861 12.8946 23.3931C11.6037 21.836 11.0009 20.3534 11.0009 18.7431C10.9746 17.2419 11.5154 15.786 12.5154 14.6661C13.0006 14.1368 13.5914 13.7152 14.2496 13.4283C14.9078 13.1413 15.6188 12.9956 16.3368 13.0004C17.4256 12.9958 18.4835 13.3624 19.3359 14.0399C19.8001 14.4002 20.2092 14.8265 20.5501 15.3051C20.8922 14.8275 21.3011 14.4014 21.7642 14.0399C22.6167 13.3624 23.6746 12.9958 24.7634 13.0004C25.4811 12.9954 26.1919 13.141 26.8498 13.4279C27.5077 13.7149 28.098 14.1367 28.5826 14.6661C29.5834 15.7857 30.125 17.2416 30.0993 18.7431C30.0993 20.3534 29.4965 21.836 28.2056 23.3931Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_29013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.195bcefa179d066d9568ed18a1070fbd.svg";
export { ForwardRef as ReactComponent };